const MAIN = 'contenthub';

export const CONTENT_HUB_DATA_TEST = {
  list: `${MAIN}-list`,
  listItem: `${MAIN}-list-item`,
  relatedItem: `${MAIN}-related-item`,
  modal: `${MAIN}-modal`,
  tabs: `${MAIN}-tabs`,
  tags: `${MAIN}-tags`,

  expertArticle: `${MAIN}-expert-article`,
  expertBack: `${MAIN}-expert-back`,
} as const;

export const CONTENT_HUB_DATA_GA = {
  main: MAIN,
  listItem: `${MAIN}-list-item`,
  relatedItem: `${MAIN}-related-item`,
  modal: `${MAIN}-modal`,
  tabs: `${MAIN}-tabs`,
  tags: `${MAIN}-tags`,
  breadcrumb: `${MAIN}-breadcrumb`,
  expertBack: `${MAIN}-expert-back`,
} as const;
